import { AppCountry } from '@/constants/app.constant'
import { Country, Language } from '@/constants/env.constant'
import { localeMap } from '@/locale/config/constants'
import moment from 'moment'

export function initMomentLocale(language: Language) {
  switch (AppCountry.current) {
    case Country.my:
      require('moment/locale/ms')
      require('moment/locale/zh-cn')
      break
    case Country.th:
      require('moment/locale/th')
      break
    case Country.ph:
      break
    case Country.vn:
      require('moment/locale/vi')
      break
    case Country.id:
    default:
      require('moment/locale/id')
  }

  // @ts-ignore
  moment.locale(localeMap[language])
}
